/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FirstCounselingAiResponseDto } from '../../models/first-counseling-ai-response-dto';
import { RequestFirstCounselingAiDto } from '../../models/request-first-counseling-ai-dto';

export interface DocumentAiControllerFirstCounselingAi$Params {
  centerId: string;
  type: string;
      body: RequestFirstCounselingAiDto
}

export function documentAiControllerFirstCounselingAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerFirstCounselingAi$Params, context?: HttpContext): Observable<StrictHttpResponse<FirstCounselingAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerFirstCounselingAi.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FirstCounselingAiResponseDto>;
    })
  );
}

documentAiControllerFirstCounselingAi.PATH = '/api/document-ai/first-counseling-ai';
